const NETWORK_INTERCEPT_TEMPLATE = `
(function() {
  var allowedDomains = __ALLOWED_DOMAINS__;

  function checkDomain(url) {
    var hostname = new URL(url, self.location && self.location.href || 'https://localhost').hostname;
    var allowed = allowedDomains.length === 0 || allowedDomains.some(function(d) { return hostname.endsWith(d); });
    if (!allowed) throw new Error('Network access denied: ' + hostname);
  }

  var _fetch = self.fetch;
  self.fetch = function(url, opts) { checkDomain(typeof url === 'string' ? url : url.url); return _fetch.call(self, url, opts); };

  if (self.XMLHttpRequest) {
    var _XHR = self.XMLHttpRequest;
    self.XMLHttpRequest = function() {
      var xhr = new _XHR();
      var _open = xhr.open.bind(xhr);
      xhr.open = function(method, url) { checkDomain(url); return _open.apply(this, arguments); };
      return xhr;
    };
  }

  if (self.WebSocket) {
    var _WS = self.WebSocket;
    self.WebSocket = function(url, protocols) { checkDomain(url); return new _WS(url, protocols); };
  }
})();
`;

export async function loadWorker(
  mainJsUrl: string,
  allowedDomains: string[] = []
): Promise<Worker> {
  const response = await fetch(mainJsUrl);
  if (!response.ok) {
    throw new Error(`Failed to load main.js: ${response.status} ${response.statusText}`);
  }
  const code = await response.text();

  const intercept = NETWORK_INTERCEPT_TEMPLATE.replace(
    "__ALLOWED_DOMAINS__",
    JSON.stringify(allowedDomains)
  );

  const fullCode = intercept + "\n" + code;
  const blob = new Blob([fullCode], { type: "application/javascript" });
  const blobUrl = URL.createObjectURL(blob);

  try {
    return new Worker(blobUrl, { type: "module" });
  } finally {
    URL.revokeObjectURL(blobUrl);
  }
}
